import React, { useEffect, useState } from 'react';

import Loader from '~/components/core/Loader';
import AIStrategyBuilderService from '~/api-services/AIStrategyBuilderService';
import { StrategyInputNode, StrategyTemplate } from '~/api-services/AIStrategyBuilderService/types';

import CreateStrategyWizard from '../CreateStrategyWizard';
import { cloneSourceFromStrategy } from '../utils/seeding';

type WizardProps = {
    templateUuid?: string;
    cloneStrategyId?: string;
    onClose: () => void;
    onCreated: (strategyId?: string) => void;
};

// Same template/clone preloading the mobile create screen does, minus the navigation.
export default function PaneWizard({ templateUuid, cloneStrategyId, onClose, onCreated }: WizardProps) {
    const [template, setTemplate] = useState<StrategyTemplate | undefined>(undefined);
    const [cloneNodes, setCloneNodes] = useState<StrategyInputNode[] | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(!!templateUuid || !!cloneStrategyId);

    useEffect(() => {
        if (!templateUuid) {
            return;
        }
        AIStrategyBuilderService.getStrategyTemplate(templateUuid)
            .then(({ data }) => {
                if (data?.status && data.returnData) {
                    setTemplate(data.returnData);
                }
            })
            .catch(() => {
                // ignore — form will render in custom mode
            })
            .finally(() => setLoading(false));
    }, [templateUuid]);

    useEffect(() => {
        if (!cloneStrategyId) {
            return;
        }
        AIStrategyBuilderService.getStrategy(cloneStrategyId, { returnInputJSON: true })
            .then(({ data }) => {
                if (data?.status && data.returnData) {
                    const source = cloneSourceFromStrategy(data.returnData);
                    setTemplate(source.template);
                    setCloneNodes(source.cloneNodes);
                }
            })
            .catch(() => {
                // ignore — form will render in custom mode
            })
            .finally(() => setLoading(false));
    }, [cloneStrategyId]);

    if (loading) {
        return <Loader loading />;
    }

    return <CreateStrategyWizard onCreated={onCreated} onClose={onClose} template={template} cloneNodes={cloneNodes} />;
}
